import React from 'react';
import { Button } from '../../../../../../base/components/Button';
import { PasswordInput } from '../../../../../../base/components/Forms/PasswordInput';
import { useAppDispatch, useAppSelector } from '../../../../../../base/hooks';
import { __t } from '../../../../../../base/utils/t';
import { settingsActions } from '../../../redux/slice/settingsSlice';

import '../styles.scss';

export const OldPassword = () => {
    const dispatch = useAppDispatch();
    const {
        fields: { password },
        errors,
    } = useAppSelector((state) => state.workerAppSettings.changeLogin);

    const inputChangeHandler = (value: unknown) => {
        dispatch(settingsActions.setChangeLoginField({ id: 'password', value }));
    };

    const submitOldPasswordHandler = () => dispatch(settingsActions.changeLoginSubmit());

    return (
        <div className='change-login'>
            <div className='change-login__form-item scroll-margin-for-fixed-header'>
                <p className='change-login__form-label'>{__t('Текущий пароль')}</p>
                <PasswordInput
                    value={password}
                    placeholder={__t('Введите пароль')}
                    onChange={inputChangeHandler}
                    errors={errors?.password}
                />
            </div>
            <Button className='change-login__button' onClick={submitOldPasswordHandler}>
                {__t('Далее')}
            </Button>
        </div>
    );
};
